import React from 'react';
import { useTranslation } from 'react-i18next';
import LocalizedLink from 'helpers/LocalizeLink';

const DocumentationButtons = (props) => {
    const { t } = useTranslation();

    return (
        <>
            <h4 className={"text-sm-center mt-4 mt-md-0 mb-12" + (props?.dark ? " text-white" : "")}>{t('labels.still_need_help')}?</h4>
            <div className="text-sm-center">
                <LocalizedLink to={'faq'} className={"btn h-32 px-12 mr-4" + (props?.dark ? " btn-dark" : "")}>
                    {t('buttons.btn_checkout_faq')}
                </LocalizedLink>
                <LocalizedLink to={'contact_us'} className={"btn h-32 px-12" + (props?.dark ? " btn-dark" : "")}>
                    {t('buttons.btn_contact_support')}
                </LocalizedLink>
            </div>
        </>
    )
}

export default DocumentationButtons;
